import { ViewModel } from 'view_models/view_model'
import { Extraction } from 'entities/extraction'

export class ExtractionViewModel extends ViewModel<Extraction> {
    public dateText = (): string => {
        return this.toDateText(this.object.date)
    }
}
